import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { AuthShell } from "@/components/auth/AuthShell";
import { Button } from "@/components/ui/button";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError(""); setMsg("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email: email.trim() });
      setMsg(data.message);
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Reset your password" subtitle="Enter your account email and we'll send a reset link.">
      <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
        <label className="block">
          <span className="overline-label">Email</span>
          <input data-testid="forgot-email-input" className="field-input mt-1 h-9" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
        </label>
        {msg && <div data-testid="forgot-success" className="rounded-md border border-teal-500/40 bg-teal-500/10 px-3 py-2 text-sm">{msg}</div>}
        {error && <div data-testid="forgot-error" className="rounded-md border border-red-500/40 bg-red-500/10 px-3 py-2 text-sm text-red-600 dark:text-red-300">{error}</div>}
        <Button data-testid="forgot-submit-button" type="submit" className="w-full h-9" disabled={busy}>{busy ? "Sending…" : "Send reset link"}</Button>
        <Link data-testid="forgot-back-link" to="/login" className="block text-center text-sm text-primary hover:underline">Back to sign in</Link>
      </form>
    </AuthShell>
  );
}
